import React from 'react';
import styled from 'styled-components';

import { TagProps } from 'antd/lib/tag';
import Icon from '../Icon';
import { ColorNameType } from '../theme';
import { BaseTag } from './common';

interface TypeTagProps extends TagProps {
  closeButtonColor?: ColorNameType;
  label: string;
  disabled?: boolean;
}

const TypeTag: React.FC<TypeTagProps> = props => {
  const { closeButtonColor = 'blue6', disabled, label, ...rest } = props;

  return (
    <StyledTag
      closable={!disabled}
      closeIcon={
        <Icon
          type="x"
          height={13}
          width={13}
          offset={[0, 1.25]}
          color={closeButtonColor}
        />
      }
      color="blue"
      data-cy={`contact-role-label-${label}`}
      {...rest}
    >
      {label}
    </StyledTag>
  );
};

const StyledTag = styled(BaseTag)``;

export default TypeTag;
